import InputOpen from './components/open'
import InputPassword from './components/password'
import InputCheck from './components/check'
import InputChecklist from './components/checklist'
import InputDateRange from './components/dateRange'
import InputDropdown from './components/dropdown'
import InputEditor from './components/editor'
import InputSlider from './components/slider'
import InputSwitch from './components/switch'

import InputAlert from './error/alert'

import InputSubmit from './submit/button'

const Input = (props) => {
  return null
}

Input.Open = InputOpen
Input.Password = InputPassword
Input.Check = InputCheck
Input.Checklist = InputChecklist
Input.DateRange = InputDateRange
Input.Dropdown = InputDropdown
Input.Editor = InputEditor
Input.Slider = InputSlider
Input.Switch = InputSwitch

Input.Alert = InputAlert

Input.Submit = InputSubmit

export default Input
